import {
  PAYMENT_METHOD,
  PAYMENT_PROVIDER,
  TRANSACTION_PARTY_TYPE,
  TRANSACTION_TYPES as TRANSACTION_TYPE
} from 'components/constants';
import { parseDateToServer } from 'services/utils';

const CONVERA_PROVIDERS = [PAYMENT_PROVIDER.CONVERA_API.name, PAYMENT_PROVIDER.CONVERA_MERCHANT.name];

export const isConveraOutgoing = (transactionType, paymentProvider) =>
  transactionType === TRANSACTION_TYPE.OUTGOING && CONVERA_PROVIDERS.includes(paymentProvider);

export const toDto = (data) => ({
  paymentMethod: data.paymentMethod,
  amount: Number(data.amount),
  tariffs:
    data.commissions
      ?.filter((c) => c.amount && c.amount !== '')
      .map((c) => ({
        ...(c.tariffId ? { tariffId: c.tariffId } : {}),
        amount: Number(c.amount)
      })) || [],
  comment: data.comment,
  commentToAdmin: data.commentToAdmin,
  documents: data.documents.map((d) => d.id),
  ...(data.payment_purpose ? { purpose: data.payment_purpose } : {}),
  ...(data.transactionType === TRANSACTION_TYPE.OUTGOING
    ? {
        senderWallet: data.senderAccount?.wallet_number,
        recipient: toTransactionParty(data)
      }
    : {
        ...(data.recipientAccount
          ? { recipientWallet: data.recipientAccount.wallet_number }
          : { transferProvider: data.paymentProvider }),
        sender: toTransactionParty(data),
        transitTransactionDetails: {
          transitTransactionId: data?.transitTransaction?.transaction_id,
          externalId: data?.externalId,
          providerCreatedAt: parseDateToServer(data?.providerCreatedAt)
        }
      })
});

export const fromErrorDto = (fields) => ({
  amount: fields?.amount,
  currency: fields?.currency,
  commissions: fields?.tariffs,
  comment: fields?.comment,
  commentToAdmin: fields?.commentToAdmin,
  senderAccount: fields?.senderWallet,
  recipientAccount: fields?.recipientWallet,
  iban: fields?.iban,
  bankCountry: fields?.bankCountry,
  accountNumber: fields?.accountNumber,
  sortCode: fields?.sortCode,
  bankName: fields?.bankName,
  bic: fields?.bic,
  firstName: fields?.firstName,
  lastName: fields?.lastName,
  companyName: fields?.companyName,
  registrationNumber: fields?.registrationNumber,
  partyAddress: fields?.beneficiaryAddress,
  partyCountry: fields?.beneficiaryCountry,
  partyState: fields?.beneficiaryState,
  partyPostCode: fields?.beneficiaryPostCode,
  partyCity: fields?.beneficiaryCity,
  transitTransaction: fields?.transitTransactionId
});

const toTransactionParty = (data) => {
  if (data.paymentMethod === PAYMENT_METHOD.INTERNAL) {
    return {
      walletNumber:
        data.transactionType === TRANSACTION_TYPE.INCOMING
          ? data.senderAccount?.wallet_number
          : data.recipientAccount?.wallet_number
    };
  }

  // For incoming SWIFT via transit transaction, use sender's bank country if available
  let bankCountryValue = data.bankCountry;
  if (
    data.transactionType === TRANSACTION_TYPE.INCOMING &&
    data.paymentMethod === PAYMENT_METHOD.SWIFT &&
    data.transitTransaction?.sender?.bankCountry
  ) {
    bankCountryValue = data.transitTransaction.sender.bankCountry;
  }

  let requisites;
  if (data.bic) {
    requisites = {
      bankCountry: bankCountryValue,
      bankName: data.bankName,
      accountNumber: data.accountNumber,
      bic: data.bic
    };
  } else if (data.sortCode) {
    requisites = {
      accountNumber: data.accountNumber,
      sortCode: data.sortCode
    };
  } else {
    requisites = {
      iban: data.iban,
      bankCountry: bankCountryValue
    };
  }

  return {
    beneficiary: {
      type: data.partyType === TRANSACTION_PARTY_TYPE.COMPANY ? 'CORPORATE' : 'INDIVIDUAL',
      ...(data.partyType === TRANSACTION_PARTY_TYPE.COMPANY
        ? {
            companyName: data.partyCompanyName
          }
        : {
            firstName: data.partyFirstName,
            lastName: data.partyLastName
          })
    },
    requisites,
    ...([PAYMENT_METHOD.SWIFT, PAYMENT_METHOD.TARGET2].includes(data.paymentMethod)
      ? {
          registrationNumber: data.registrationNumber,
          beneficiaryCountry: data.partyCountry,
          beneficiaryAddress: data.partyAddress,
          beneficiaryCity: data.partyCity,
          beneficiaryPostCode: data.partyPostCode,
          ...(isConveraOutgoing(data.transactionType, data.paymentProvider)
            ? { beneficiaryState: data.partyState }
            : {})
        }
      : {})
  };
};
